import _ from 'lodash';
import APP_CONFIG from '../app.config';


/**
 * Directives on analytics
 */
const mod = angular.module('app.analytics.directives', [])

/**
 * Includes the javascript for Google Tag Manager when ga code is defined (beta/production)
 */
.directive('oralGoogleTagManager', function () {
  return {
    link: () => {
      if (!APP_CONFIG.gtm) {
        return;
      }
      // Google Tag Manager script loading
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', APP_CONFIG.gtm);
    }
  };
})

/**
 * Includes the javascript for Google Analytics when ga code is defined (beta/production)
 */
.directive('oralGoogleAnalytics', function ($window) {
  return {
    link: () => {
      if (!APP_CONFIG.ga) {
        return;
      }
      // Google Analytics script loading
      (function getGa(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      }(window,document,'script','//www.google-analytics.com/analytics.js','ga'));
      $window.ga('create', APP_CONFIG.ga, {'siteSpeedSampleRate': 100});
    }
  };
})

/**
 * Includes the javascript for Facebook Pixel when ga code is defined (beta/production)
 */
.directive('oralFacebookPixel', function ($window) {
  return {
    link: () => {
      if (!APP_CONFIG.facebook) {
        return;
      }
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','//connect.facebook.net/en_US/fbevents.js');
      $window.fbq('init', APP_CONFIG.facebook);
      $window.fbq('track', "PageView");
    }
  };
})

/**
 * Includes the javascript for Google Content Experiments when ga code is defined (beta/production)
 */
.directive('oralGoogleExperiments', function () {
  return {
    link: scope => {

      if (angular.isUndefined(APP_CONFIG.ga) || angular.isUndefined(APP_CONFIG.gaExperiment ||
      _.isNull(APP_CONFIG.ga) || _.isNull(APP_CONFIG.gaExperiment)) ) {
        return;
      }

      scope.experimentUrl = '//www.google-analytics.com/cx/api.js?experiment=' + APP_CONFIG.gaExperiment;

      // Angular really doesn't want to load scripts with dynamic urls even with $sce rules in place
      // so load the experiment library manually, use code from
      // http://stackoverflow.com/questions/15939913/single-page-application-load-js-file-dynamically-based-on-partial-view
      function loadScript (url, type, charset) {
        if (angular.isUndefined(type)) { type = 'text/javascript'; }
        if (url) {
          var script = document.querySelector("script[src*='" + url + "']");
          if (!script) {
            var heads = document.getElementsByTagName("head");
            if (heads && heads.length) {
              var head = heads[0];
              if (head) {
                script = document.createElement('script');
                script.setAttribute('src', url);
                script.setAttribute('type', type);
                if (angular.isDefined(charset)) { script.setAttribute('charset', charset); }
                head.appendChild(script);
              }
            }
          }

          return script;
        }
      }

      loadScript(scope.experimentUrl);
    }
  };
})
;

function appendAnalytics($document, $compile, $rootScope) {
  'ngInject';

  const analytics = $document.find('oral-google-analytics');
  // Make sure the element is not built multiple times
  if (analytics.length > 0) {
    return;
  }

  // A custom ID that will contain all of our analytics directives
  let container = document.querySelector('#oral-analytics-container');

  if (container == null) {
    return;
  }

  container = angular.element(container);

  // Get the container element and prepend analytics directives if it doesn't exist yet
  container.append($compile(
    '<oral-google-analytics></oral-google-analytics>' +
    '<oral-google-tag-manager></oral-google-tag-manager>' +
    '<oral-facebook-pixel></oral-facebook-pixel>' +
    '<oral-google-experiments></oral-google-experiments>'
  )($rootScope));
}
export {
  appendAnalytics
}

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/analytics/analytics.directives.js